import React from 'react';

const ClassSelector = ({ classes, onSelect, selectedClass }) => {
    return (
        <select
            value={selectedClass ? selectedClass._id : ''}
            onChange={(e) => {
                const selected = classes && classes.length > 0 ? classes.find(c => c._id === e.target.value) : null;
                console.log("Selected class in ClassSelector:", selected);
                onSelect(selected);
            }}
        >
            <option value="">Select a Class</option>
            {classes && classes.length > 0 ? (
                classes.map((c) => (
                    <option key={c._id} value={c._id}>
                        {c.className} - {c.teacher.firstName} {c.teacher.lastName}
                    </option>
                ))
            ) : (
                <option value="" disabled>No classes available</option>
            )}
        </select>
    );
};

export default ClassSelector;
